type Assert = (value: unknown, message?: string | Error) => asserts value;

/** Browser-safe stand-in for Node's `assert.strict`, so client bundles need no `assert` polyfill. */
export const assert: Assert = (value, message = "Assertion failed") => {
  if (!value) {
    throw message instanceof Error ? message : new Error(message);
  }
};
